import * as React from "react";
import DatePicker from 'react-datepicker';
import {currency} from "~/lib/formatters";
import {useCallback} from "react";

const SalesTotalsFilter = (props) => {
  const {salesTotals, onStartDate, onEndDate, initialValues: {startDate, endDate}} = props;

  const handleStartDate = (dt) => {
    if (onStartDate) {
      onStartDate(dt);
    }
  };

  const handleEndDate = (dt) => {
    if (onEndDate) {
      onEndDate(dt);
    }
  };

  return (
    <div className="filter__cont" style={{zIndex: 1}}>
      <div className="filter__title"/>
      <div className="filter__controls">
        <React.Fragment>
          <div className="input--date">
            <DatePicker
              onChange={handleStartDate}
              selected={startDate}
              popperPlacement="bottom-end"
              placeholderText="Start Date"/>
          </div>
          <div className="btn btn--text--di btn--lg">TO</div>
          <div className="input--date">
            <DatePicker
              onChange={handleEndDate}
              selected={endDate}
              popperPlacement="bottom-end"
              placeholderText="End Date"/>
          </div>
        </React.Fragment>
        <div className="filter__info">
          <div className="filter__info--block">
            <div className="btn btn--text--di btn--lg">Sales:</div>
            <div className="btn btn--text--di btn--lg">{salesTotals.totalCountOfSales}</div>
          </div>
          <div className="filter__info--block">
            <div className="btn btn--text--di btn--lg">Total:</div>
            <div className="btn btn--text--di btn--lg">${currency(salesTotals.totalAmountOfSales)}</div>
          </div>
        </div>
      </div>
    </div>);
}

export default SalesTotalsFilter;
